'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { List } from 'immutable';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const getLangKey = key => `mab.deleteModal.${key}`;
export default class MABVariationDeleteModal extends PureComponent {
  constructor(...args) {
    super(...args);
    this.getMatcherLabel = () => {
      const {
        deletedVariations
      } = this.props;
      return I18n.text(getLangKey('matcherLabel'), {
        count: deletedVariations.size
      });
    };
  }
  getMessage() {
    const {
      afterChangesVariationCount,
      deletedVariations,
      mabExperimentIsStarted
    } = this.props;
    const messageKeyPostfix = mabExperimentIsStarted ? 'testWillEnd' : afterChangesVariationCount === 0 ? 'testWillBeDeleted' : 'default';
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${getLangKey('message')}.${messageKeyPostfix}`,
        options: {
          count: deletedVariations.size,
          variationName: deletedVariations.first().get('name')
        }
      })
    });
  }
  render() {
    const {
      onClose,
      onDelete
    } = this.props;
    return /*#__PURE__*/_jsx(ConfirmModal, {
      confirmLabel: I18n.text(getLangKey('confirm')),
      confirmUse: "danger",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('description')
      }),
      match: I18n.text(getLangKey('matcherValue')),
      matcherLabel: this.getMatcherLabel(),
      message: this.getMessage(),
      onConfirm: onDelete,
      onReject: onClose,
      rejectLabel: I18n.text(getLangKey('cancel')),
      use: "danger"
    });
  }
}
MABVariationDeleteModal.propTypes = {
  afterChangesVariationCount: PropTypes.number.isRequired,
  deletedVariations: PropTypes.instanceOf(List).isRequired,
  mabExperimentIsStarted: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};